<template>
  <div ref="whVideo" class="wh-canvas-container">
    <canvas class="wh-canvas" :style="canvasStyle" :id="`canvas${md5}`"></canvas>
    <VideoToolbar v-if="options && options.toolbar" class="wh-toolbar" @action="handleAction"></VideoToolbar>
    <div v-show="startLoading" class="wh-error">
      <div>
        <p class="info">视频加载中...</p>
      </div>
    </div>
    <div v-show="whErrorShow" class="wh-error">
      <div>
        <p class="info">{{ wherror.msg }}</p>
        <a class="btn" @click="retryPlay">尝试起播</a>
      </div>
    </div>
  </div>
</template>
<script>
import { hex_md5 } from '../utils/md5'
import { WHPlayer } from './../utils/plugin/whPlayer'
import { Action } from './toolbar/action'
import { EventBus } from './../utils/eventbus'
import VideoToolbar from './toolbar/VideoToolbar.vue'

export default {
  props: ['src', 'options'],
  components: { VideoToolbar },
  data() {
    return {
      md5: '',
      player: null,
      isFullscreen: false,
      whErrorShow: false,
      wherror: {
        msg: ''
      },
      isSuccess: false,
      startLoading: false,
      errorTimer: null
    }
  },
  computed: {
    // canvas宽高
    canvasStyle() {
      if (this.options && this.options.toolbar) {
        return {
          width: '100%',
          height: 'calc(100% - 30px)'
        }
      }
      return {
        height: '100%',
        width: '100%'
      }
    }
  },
  watch: {
    src: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.stopPlay()
          this.md5 = hex_md5(newVal)
          this.$nextTick(() => {
            this.startPlay()
          })
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.stopPlay()
  },
  mounted() {
    if (!this.src) {
      return
    }

    this.md5 = hex_md5(this.src)
    this.startPlay()
  },
  methods: {
    startPlay() {
      const canvasDom = document.getElementById(`canvas${this.md5}`)

      if (!canvasDom) {
        return
      }
      this.isSuccess = false;
      this.startLoading = true;
      this.player = new WHPlayer(this.options, this.handleDownloadCallback.bind(this))

      EventBus.$emit('toolbar', Action.pause)
      EventBus.$emit('toolbar', Action.fullscreen)
      this.player.start(
        this.src,
        canvasDom,
        function () {},
        function () {},
        function () {}
      )
    },
    retryPlay() {
      this.whErrorShow = false
      this.stopPlay()
      this.startPlay()
    },
    handleDownloadCallback(e) {
      if (this.isSuccess) {
        return
      }
      var data = e.data

      if (data.v === 0 || data.v === 2) {
        this.whErrorShow = true
        this.wherror.msg = 'WebSocket链路失败，请检查！'
        return
      }

      if (!this.isSuccess) {
        if (!this.errorTimer) {
          this.errorTimer = setTimeout(() => {
            this.startLoading = false
            this.whErrorShow = true
            this.wherror.msg = '未接受到服务端数据流下发，请检查！'
          }, 30000)
        }
      }

      if (data.t == 0 && data.d) {
        this.startLoading = false
        this.whErrorShow = false
        this.isSuccess = true
        this.errorTimer && clearTimeout(this.errorTimer)
        this.errorTimer = null
      }
    },
    handleAction(val) {
      switch (val) {
        case Action.play:
          EventBus.$emit('toolbar', Action.pause)
          this.player.startRender()
          break
        case Action.pause:
          EventBus.$emit('toolbar', Action.play)
          this.player.stopRender()
          break
        case Action.fullscreen:
          this.fullscreen(val)
          break
        case Action.exitFullscreen:
          this.fullscreen(val)
          break
        default:
          break
      }
    },
    fullscreen(val) {
      // this.isFullscreen = !this.isFullscreen
      if (val === Action.fullscreen) {
        EventBus.$emit('toolbar', Action.exitFullscreen)
        this.$refs.whVideo && this.$refs.whVideo.requestFullscreen()
      } else {
        EventBus.$emit('toolbar', Action.fullscreen)
        document.exitFullscreen()
      }
    },
    stopPlay() {
      this.whErrorShow = false
      this.startLoading = false;
      this.errorTimer && clearTimeout(this.errorTimer)
      // const canvasDom = document.getElementById(`canvas${this.md5}`)
      if (this.player) {
        this.player.clear();
        this.player.stop()
      }
    },
    dispose() {
      if (this.player) {
        this.player.stop()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wh-canvas-container {
  width: 100%;
  height: 100%;
  position: relative;
  .wh-canvas {
    width: 100%;
    height: calc(100% - 30px);
  }
  .wh-toolbar {
    height: 30px;
    width: 100%;
  }
  .wh-error {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .info {
      color: #fff;
    }
    .btn {
      color: #3c9af3;
    }
  }
}
</style>